import axios from "axios"
import { saveAs } from "file-saver"

const apiUrl = "/api/"

function buildUrl(path) {
  return `${apiUrl}${path}`
}

function buildOptions(options = {}, signal = null) {
  if (!options.headers) {
    options.headers = {}
  }

  if (signal) options.signal = signal

  options.headers.Authorization = localStorage.getItem("token")
  return options
}

function blobToBase64(blob) {
  return new Promise((resolve, _) => {
    const reader = new FileReader()
    reader.onloadend = () => resolve(reader.result)
    reader.readAsDataURL(blob)
  })
}
export default {
  display: {
    createAlbum(formData) {
      let url = buildUrl("display/albums")
      return axios.post(url, formData, buildOptions()).then((res) => res.data)
    },
    fetchAlbums() {
      let url = buildUrl("display/albums")
      return axios.get(url, buildOptions()).then((res) => res.data)
    },
    fetchAlbum(id) {
      let url = buildUrl(`display/albums/${id}`)
      return axios.get(url, buildOptions()).then((res) => res.data)
    },
    uploadPhotos(albumId, files) {
      const form = new FormData()
      files.forEach((f) => form.append("photos", f))
      return axios
        .post(buildUrl(`display/albums/${albumId}/photos`), form, buildOptions({ headers: { "Content-Type": "multipart/form-data" } }))
        .then((r) => r.data)
    },
    deletePhoto(mediaItemId, albumId) {
      return axios.delete(buildUrl(`display/photos/${mediaItemId}` + "?albumId=" + albumId), buildOptions()).then((r) => r.data)
    },
  },
}
